export interface IReportDelivery {
  totalValue: number;
  items: IReportDeliveryItem[];
}

export interface IReportDeliveryItem {
  orderId: string;
  reference: string;
  createdAt: string;
  fulfilledAt: string;
  value: number;
  currencySymbol: string;
  country: string;
  locationName: string;
  customer: { locationName: string; entity: string };
  operatorName: string;
  batchId: string;
  externalOrderId: string;
  externalInvoiceId: string;
}
